import { Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Add } from "@mui/icons-material";
import PartnersDataGrid from "./PartnersDataGrid";
import { FullPagePaperLayout } from "pages/Layouts/FullPagePaperLayout";
import { PageActions, PageBreadcrumbs, PageSubtitle, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export function Partners() {
  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Logistics" }]} />
      <PageTitle>Partners</PageTitle>
      <PageSubtitle>View all the partners that work with Revivn, their locations and contacts.</PageSubtitle>
      <PageActions>
        <Button component={RouterLink} variant="contained" to={`/logistics/partners/new`} startIcon={<Add />}>
          Add New Partner
        </Button>
      </PageActions>

      <PartnersDataGrid />
    </FullPagePaperLayout>
  );
}
